import React from 'react';

export function SkillLevel({ level }) {
  return <>
  <p>
<span className="skill-level-header">{level.header}</span> – {level.content}
  </p>
  </>
}
